import type { HTMLAttributes, ReactNode } from 'react';
import React from 'react';
import type { AccessibleClickableContainerProps } from '../accessibility';
import { AccessibleClickableContainer } from '../accessibility';

/**
 * Defines the list items, can contain any JSX.Elements (e.g. {@link AccessibleClickableContainer})
 */
export interface ListItemProps
  extends Partial<AccessibleClickableContainerProps> {
  children: ReactNode;
  className?: string;
}

export function ListItem({
  ...props
}: Readonly<ListItemProps> &
  Pick<HTMLAttributes<HTMLElement>, 'style'>): JSX.Element {
  const classNames = ['ehs-list-item'];
  if (props.className) {
    classNames.push(props.className);
  }
  return props.onClick ? (
    <li className={classNames.join(' ').trim()}>
      <AccessibleClickableContainer
        {...props}
        className="ehs-clickable"
        onClick={props.onClick}
      >
        {props.children}
      </AccessibleClickableContainer>
    </li>
  ) : (
    <li {...props} className={classNames.join(' ').trim()}>
      {props.children}
    </li>
  );
}
